import {BaseWrapper} from '../../framework/parameters/BaseWrapper';
import {User} from '../message/User';
import {UserCriteria} from './UserCriteria';
import {UserScenario} from './UserScenario';

export class UserWrapper extends BaseWrapper<User, UserCriteria, UserScenario>  {
token: Object;
}

